import httpClient from "@/api/httpClient.js";

const resource = "jackpots";

export function emptyJackpot(accountableEntityId) {
  return httpClient.put(`/${resource}/${accountableEntityId}`, { accountableEntityId: accountableEntityId });
}
